exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".small-box>.small-box-footer {\r\n    padding: 10px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/src/app/components/home/home.component.css
// module id = ../../../../../src/app/components/home/home.component.css
// module chunks = 0